// libs
import { Record, List } from "immutable";

// local
import NewsItem from "./NewsItem";


const BaseRecord = Record({
  items: List()
});

export default class NewsCollection extends BaseRecord {
  init(data) {
    let items = List();

    data.forEach((item) => {
      if (item.id && item.link && item.message && item.updated_time && items.size < 5) {
        items = items.push(new NewsItem().init(item));
      }
    });

    return this.set("items", items);
  }
}



// WEBPACK FOOTER //
// ./src/js/models/NewsCollection.js